// Client-owned ("masked") domains served by this platform. Hostnames here do not
// follow the <tenant>.vlookup.ai convention, so subdomain parsing cannot derive
// the tenant — they must be mapped explicitly, and API/static calls must stay
// same-origin (the masked vhost proxies /api on the same box).
const CUSTOM_DOMAIN_TENANTS = {
  "mentoring-uat.sid.org.sg": "siduat",
  "mentoring.sid.org.sg": "sid",
};

// Tenant for a masked hostname, or null to fall through to subdomain parsing.
const resolveTenant = (hostname) => CUSTOM_DOMAIN_TENANTS[hostname] || null;

const isCustomDomain = (hostname) => Boolean(CUSTOM_DOMAIN_TENANTS[hostname]);

module.exports = { CUSTOM_DOMAIN_TENANTS, resolveTenant, isCustomDomain };